<template>
  <div class="custom-charges-input clearfix">
    <div class="form-group row">
      <div class="col-sm-12">
        <h4>
          {{ options.label }}
          <span v-if="options.required" class="required">*</span>
        </h4>
      </div>
    </div>
    <div class="form-group row">
      <div class="col-sm-12">
        <template v-for="(input, index) in inputs">
          <component
            :is="input.type + '-input'"
            :options="input"
            ref="component"
            @input="saveValue($event, index)"
            :value="input.value">
          </component>
          <div class="remove-input">
            <a
              class="interactive-cursor"
              @click="removeInput(index)"
              type="button">
              [ <span class="fa fa-times fa-fw"></span> Remove ]
            </a>
          </div>
        </template>
      </div>
      <div class="col-sm-8 offset-sm-4">
        <div class="text-right" v-if="options.methods.length > 1">
          <div class="btn-group">
            <button v-for="method in options.methods"
              class="btn btn-default btn-sm"
              @click="addInput(method)"
              type="button">
              <span class="fa fa-plus fa-fw"></span> Add {{ method.label }}
            </button>
          </div>
        </div>
        <span :class="validationClass" v-show="validationMessage">
          {{ validationMessage }}
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import {
  validationClass,
  validationIcon,
  validationMessage
} from '@/util/helpers'
import ObjectSelectInput from '@/components/inputs/ObjectSelectInput'
import CustomChargeInput from '@/components/inputs/CustomChargeInput'
import Util from '@server/util'

export default {
  name: 'CustomChargesInput',
  components: {
    ObjectSelectInput,
    CustomChargeInput
  },
  props: {
    value: {
      type: Array
    },
    options: {
      type: Object,
      default () {
        return {
          label: 'Text',
          name: 'customCharges',
          methods: [],
          value: [],
          required: false,
          muaCharges: []
        }
      }
    }
  },
  data () {
    return {
      isDirty: false,
      isValid: false,
      inputs: [],
      maxChargeAmount: false
    }
  },
  computed: {
    validationClass,
    validationIcon,
    validationMessage,
    invalidMessage () {
      if (!this.inputs.length) {
        return 'You did not add any ' + this.options.label
      } else if (this.maxChargeAmount && this.total > this.maxChargeAmount) {
        return 'You cannot charge more than the remaining $' + Util.round(this.maxChargeAmount)
      } else {
        return 'You did not fill out all ' + this.options.label + ' correctly'
      }
    },
    total () {
      let tally = 0
      for (let charge of this.value) {
        if (charge) {
          if (charge.amountValue && charge.descriptionValue) {
            tally += Util.round(charge.amountValue)
          } else {
            let muaCharge = this.options.muaCharges.find(function (el) {
              return el.uuid === charge
            })
            if (muaCharge) {
              tally += Util.round(muaCharge.cost)
            }
          }
        }
      }
      return tally
    }
  },
  mounted () {
    if (this.options.maxChargeAmount) {
      this.maxChargeAmount = this.options.maxChargeAmount
    }
  },
  methods: {
    addInput (input) {
      this.isValid = true
      this.inputs.push(Object.assign({}, input))
    },
    removeInput (index) {
      this.inputs.splice(index, 1)
      this.value.splice(index, 1)
      this.$emit('input', this.value)
      for (let comp of this.$refs.component) {
        if (comp.$options._componentTag === 'object-select-input') {
          comp.updateChoices()
        }
      }
    },
    saveValue (val, index) {
      this.isDirty = true
      this.value.splice(index, 1, val)
      this.inputs[index].value = val
      this.$emit('input', this.value)
    },
    validate () {
      this.isDirty = true
      if (!this.inputs.length) {
        this.isValid = false
      } else if (this.maxChargeAmount && this.total > this.maxChargeAmount) {
        this.isValid = false
      } else {
        this.isValid = true
        for (let child of this.$children) {
          child.isDirty = true
          if (!child.isValid) this.isValid = false
        }
        this.$emit('input', this.value)
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/inputs/CustomChargesInput.vue